import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import mouseIcon from '@/assets/mouseIcon.png';
import roundedBg from '@/assets/roundedBg.png';
import bg from '@/assets/green-bg.png';
import { LinearProgress, linearProgressClasses, styled } from '@mui/material';
import { Button } from '@/components/Elements';
import DescriptionTabs from './DescriptionTabs';
import Footer from '@/components/Layout/Footer/Footer';
import EmissionTab from './EmissionTab';
import DocumentsTab from './DocumentsTab';
import DiscussionTab from './DiscussionTab';
export const InvestmentDetails = () => {
  const router = useNavigate();
  const auth = useAuth();
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#FFE9ED',
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: '#FF385C',
    },
  }));
  const [activeTab, setActiveTab] = useState('Description');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Description':
        return <DescriptionTabs />;
      case 'Emission':
        return <EmissionTab />;
      case 'Discussion':
        return <DiscussionTab />;
      case 'Documents':
        return <DocumentsTab />;
      default:
        return null;
    }
  };
  return (
    <>
      <div className="section investement-details relative py-5" style={{ background: '#e6f3f3' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <div className="content-wrapper">
                <span className="ticker-label"></span>
                <button className="wlcm-text border-0 bg-black text-white">
                  Welcome to the Reeipo
                </button>
                <h3 className="f-40 bold  mt-4">
                  Unlock Lucrative Real Estate Investments with Us
                </h3>
                <p className="f-14">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua.
                </p>
                <a href="#" className="link mt-4 d-block">
                  Start Explore
                </a>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="investr-colm">
                <h4 className="f-20">ADVAC AS</h4>
                <hr />
                <h6 className="text-black">NOK 0.00</h6>
                <div className="nok-progress mb-3">
                  <BorderLinearProgress variant="determinate" value={50} />
                  <div className="f-13 d-flex justify-between text-black">
                    <span>NOK 0.00</span>
                    <span>NOK 12550.00</span>
                  </div>
                </div>
                <div className="nok-card mb-4">
                  <div className="row">
                    <div className="col-12 col-md-6 col-xl-3">
                      <p className="f-13">Minimum Goal</p>
                      <p className="text-black f-14">0%</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <p className="f-13">No. of Drawings </p>
                      <p className="text-black f-14">0%</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <p className="f-13">Nominal Share Price </p>
                      <p className="text-black f-14">NOK 0%</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <p className="f-13">Share for Sale</p>
                      <p className="text-black f-14">0%</p>
                    </div>
                  </div>
                  <hr />
                  <p className="f-13 d-flex justify-between price-nok">
                    <span>The Valuation</span>
                    <span className="text-black">NOK 24,000,080.00</span>
                  </p>
                  <p className="f-13 d-flex justify-between price-nok">
                    <span>Shares for Sale </span>
                    <span className="text-black">15,385</span>
                  </p>
                  <p className="f-13 d-flex justify-between price-nok">
                    <span>Remaining Shares</span>
                    <span className="text-black">1233</span>
                  </p>
                  <p className="f-13 d-flex justify-between price-nok">
                    <span>Minimum Drawing</span>
                    <span className="text-black">3 shares (NOK 1,560.00)</span>
                  </p>
                  <p className="f-13 d-flex justify-between price-nok">
                    <span>Maximum Drawing </span>
                    <span className="text-black">15,385 shares (NOK 8,000,200.00)</span>
                  </p>
                </div>
                <div className="row">
                  <div className="col-12 col-md-8">
                    <p className="f-12">
                      Before buying shares, you should understand the risks involved. Don't invest
                      more than you can afford to lose.
                    </p>
                  </div>
                  <div className="col-12 col-md-4 text-end">
                    <Button className="black-btn bg-black" size="sm">
                      Buy Shares
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-bottom-btn py-2 ">
            <img src={roundedBg} alt="" className="position-absolute d-block w-100 bg-img" />
            <button className="d-flex gap-3 align-items-center mx-auto">
              <img src={mouseIcon} alt="" className="d-block w-100" />
              Scroll Down To Discover
            </button>
          </div>
        </div>
      </div>
      <div className="investr-tabs">
        <div className="container">
          <div className="tabs-descrp-btns d-flex gap-3 justify-center align-items-center">
            {/* Buttons to switch tabs */}
            <Button
              className={activeTab === 'Description' ? 'active' : ''}
              onClick={() => setActiveTab('Description')}
            >
              Description
            </Button>
            <Button
              className={activeTab === 'Emission' ? 'active' : ''}
              onClick={() => setActiveTab('Emission')}
            >
              Emission
            </Button>
            <Button
              className={activeTab === 'Discussion' ? 'active' : ''}
              onClick={() => setActiveTab('Discussion')}
            >
              Discussion
            </Button>
            <Button
              className={activeTab === 'Documents' ? 'active' : ''}
              onClick={() => setActiveTab('Documents')}
            >
              Documents
            </Button>
          </div>
          <div className="tabs-invet-data">
           
            {renderTabContent()}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
